import { API_TIMEOUT } from "Const"
import axios from "./axios"
/**
 * 型式から車名一覧取得APIのリクエスト
 * @param {any} req - リクエスト用JSON
 * @return {object} - 型式から車名一覧取得APIのレスポンス結果
 */
export default async function getCarNmList(req: any) {
  try {
    const res = await axios.post("/car_name", req, API_TIMEOUT)
    return res
  } catch (err) {
    return err
  }
}
